import React from "react";
import { Link } from "gatsby";

const PersonList = ({ people }) => (
  <div>
    <h3>People:</h3>
    <ul>
      {people.map((person) => (
        <li key={person._id}>
          <Link to={`/person/${person._id}`}>{person.title}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export default PersonList;
